import { Injectable, signal } from '@angular/core';
import enLangJson from 'src/assets/i18n/resources-locale_en.json';
import esLangJson from 'src/assets/i18n/resources-locale_es.json';

import { AppConstants } from '../constants/app-constants';

@Injectable({
  providedIn: 'root',
})
export class LanguageChangeService {
  private languageChanged = signal(0);

  public get languageChangedSignal() {
    return this.languageChanged;
  }

  public use(lang: string): Promise<any> {
    AppConstants.preferredLanguageData = {};
    AppConstants.selectedLanguage = lang;

    switch (lang) {
      case 'en':
        AppConstants.preferredLanguageData = enLangJson;
        break;
      case 'es':
        AppConstants.preferredLanguageData = esLangJson;
        break;
      default:
        AppConstants.preferredLanguageData = enLangJson;
        break;
    }
    this.languageChanged.set(this.languageChanged() + 1);
    return Promise.resolve(AppConstants.preferredLanguageData);
  }

  public translate(key: string): string {
    let value = AppConstants.preferredLanguageData;

    value = value?.[key]?.value;
    if (!value) return key;

    return JSON.stringify(value).replace(/^"|"$/g, '');
  }
}
